export default __webpack_public_path__ + "static/media/2cd43b_8cde352199ec41958100ae808bea9c51_mv2.f4bfdda9.png";